export const STATUS_META = {
  SUBMITTED: { color: "#94A3B8", label: "Submitted" },
  REVIEWING: { color: "#60A5FA", label: "Reviewing" },
  QUOTED: { color: "#A78BFA", label: "Quoted" },
  APPROVED: { color: "#34D399", label: "Approved" },
  "IN PROGRESS": { color: "#D4AF37", label: "In Progress" },
  "AWAITING EXTERNAL TRADE": { color: "#F59E0B", label: "Awaiting Trade" },
  "QUALITY CHECK": { color: "#EC4899", label: "Quality Check" },
  "READY FOR COLLECTION": { color: "#10B981", label: "Ready" },
  COMPLETED: { color: "#059669", label: "Completed" },
  CANCELLED: { color: "#6B7280", label: "Cancelled" },
};

export const JOB_FLOW = [
  "SUBMITTED", "REVIEWING", "QUOTED", "APPROVED", "IN PROGRESS",
  "AWAITING EXTERNAL TRADE", "QUALITY CHECK", "READY FOR COLLECTION", "COMPLETED",
];

export function StatusBadge({ status, testid }) {
  const meta = STATUS_META[status] || { color: "#8C867A", label: status };
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[0.68rem] font-medium uppercase tracking-wider rounded-sm"
      style={{ color: meta.color, backgroundColor: `${meta.color}18`, border: `1px solid ${meta.color}33` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
}

export function UrgentTag() {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-[0.6rem] font-semibold uppercase tracking-widest rounded-sm"
      style={{ color: "#F59E0B", backgroundColor: "rgba(245,158,11,0.12)", border: "1px solid rgba(245,158,11,0.3)" }}
    >
      Urgent
    </span>
  );
}
